import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import '../../../util/styles/index.js';
import { useListBox } from '@react-aria/listbox';
import { mergeProps } from '@react-aria/utils';
import { useListState } from '@react-stately/list';
import { useSelectAutocompleteContext } from '../../form-controls/components/Select/components/SelectAutocomplete/hooks/useSelectAutocompleteContext.js';
import { useAdsStyles } from '../../../util/styles/hooks/useAdsStyles.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSelectionListBox = function useSelectionListBox(props) {
  var children = props.children,
    propState = props.state,
    disableClearOnEsc = props.disableClearOnEsc,
    onSelectionChange = props.onSelectionChange,
    onAction = props.onAction;
  var listBoxRef = React.useRef(null);
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var _useSelectAutocomplet = useSelectAutocompleteContext(),
    collectionProps = _useSelectAutocomplet.collectionProps,
    filter = _useSelectAutocomplet.filter;
  var nodeFilter = React.useCallback(function (nodes) {
    return Array.from(nodes).filter(function (node) {
      return !filter || filter(node.textValue);
    });
  }, [filter]);
  var innerState = useListState(_objectSpread(_objectSpread({}, props), {}, {
    filter: nodeFilter,
    children: children,
    onSelectionChange: onSelectionChange
  }));
  var state = propState || innerState;
  var _useReactAriaListBox = useListBox(_objectSpread(_objectSpread(_objectSpread({}, props), collectionProps), {}, {
      onAction: onAction
    }), state, listBoxRef),
    listBoxProps = _useReactAriaListBox.listBoxProps,
    labelProps = _useReactAriaListBox.labelProps;
  var listBoxStyle = mapAdsStyles({
    p: '0',
    m: '0',
    listStyle: 'none',
    overflow: 'visible'
  });
  var onKeyDown = React.useCallback(function (event) {
    // To make sure to not clear the selection when user hit the escape key
    if (disableClearOnEsc && (event === null || event === void 0 ? void 0 : event.key) === 'Escape') {
      event.preventDefault();
    } else if (listBoxProps.onKeyDown) {
      listBoxProps.onKeyDown(event);
    }
  }, [disableClearOnEsc, listBoxProps]);
  var labelStyle = mapAdsStyles({
    pb: '4'
  });
  return {
    state: state,
    listBoxProps: mergeProps(_objectSpread(_objectSpread({}, listBoxProps), {}, {
      onKeyDown: onKeyDown
    }), listBoxStyle),
    listBoxRef: listBoxRef,
    labelProps: mergeProps(labelProps, labelStyle),
    style: listBoxStyle
  };
};

export { useSelectionListBox };
//# sourceMappingURL=useSelectionListBox.js.map
